import { ICard, ICreditCard, PaymentMethods } from "hooks/usePayment";

export function percentagemAndSum(value: number, percentage: number) {
  return Number((value * percentage).toFixed(2));
}

export const isCard = (method: PaymentMethods): method is ICard | ICreditCard => {
  return ["credit", "debit"].includes(method.typeMethod)
}